// @flow
import React from 'react'
import {Route, Switch} from 'react-router-dom'
// eslint-disable-next-line no-unused-vars
import I18n from 'I18n'
import {ConnectedRouter} from 'react-router-redux'
import history from './createHistory'

import {adminURL} from 'modules/Common/constants/index'

import AdminCompanyList from './Admin/containers/AdminCompanyListContainer'
import AdminEditComapny from './Admin/containers/EditCompanyContainer'
import AdminCompanyDetail from './Admin/containers/CompanyDetailContainer'
import AdminAMList from './Admin/containers/AdminAMListContainer'
import AdminEditAM from './Admin/containers/EditAMContainer'
import ClientList from './Admin/containers/ClientListContainer'

import styles from './MainContainer.module.scss'

const AdminMain = () => (
  <ConnectedRouter history={history}>
    <div className={styles['admin-main-container']}>
      <Route exact path={adminURL.home} component={AdminCompanyList} />
      <Switch>
        <Route exact path={adminURL.companies.index} component={AdminCompanyList} />
        <Route exact path={adminURL.companies.detail} component={AdminCompanyDetail} />
        <Route exact path={adminURL.companies.edit} component={AdminEditComapny} />
      </Switch>
      <Switch>
        <Route exact path={adminURL.accountManagers.index} component={AdminAMList} />
        <Route exact path={adminURL.accountManagers.edit} component={AdminEditAM} />
      </Switch>
      <Switch>
        <Route exact path={adminURL.clients.index} component={ClientList} />
      </Switch>
    </div>
  </ConnectedRouter>
)

export default AdminMain
